module.exports = __webpack_public_path__ + "img/collection_empty.8c1f8cbb.png";